export default __webpack_public_path__ + "static/media/escudo.14c48222.svg";